import Vue from "vue";
import Vuex from "vuex";
import Cookie from "js-cookie";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userAvatar: "",
    userName: "",
    userPermissions: [],
  },
  getters: {},
  mutations: {
    getUserAvatar(state, userAvatar) {
      state.userAvatar = userAvatar;
    },
    getUserName(state, userName) {
      state.userName = userName;
    },
    getAuthPermissions(state, userPermissions) {
      state.userPermissions = userPermissions;
    },
  },
  actions: {
    logout() {
      const DOMAIN = process.env.VUE_APP_DOMAIN;
      Cookie.remove("uid", { domain: DOMAIN });
      Cookie.remove("token", { domain: DOMAIN });
      Cookie.remove("uname", { domain: DOMAIN });
      Cookie.remove("avatar", { domain: DOMAIN });
      Cookie.remove("_vip_token", { domain: DOMAIN });
      Cookie.remove("nickname", { domain: DOMAIN });
      const referer = window.location.href;
      const PASSPORT_PREFIX = "https://account" + process.env.VUE_APP_DOMAIN;
      window.location.href = PASSPORT_PREFIX + "/?referer=" + referer;
    },
  },
});

export default store;
